export const scrollToElement = (element, offset = -60) => {
  if (element) {
    setTimeout(() => {
      const y = getAbsoluteOffsetTop(element) + offset
      console.log({ y })
      window.scroll(0, y);
      element.focus();
    }, 300)
  }
}

const getAbsoluteOffsetTop = (element) => {
  let top = 0
  do {
    top += element.offsetTop || 0
    element = element.offsetParent
  } while (element)
  return top
}
